<template>
  <h1 v-if="!isNew" class="mb-4 text-2xl font-semibold text-gray-900">
    {{ view ? 'Client' : 'Modifier client' }} # {{ id }}
  </h1>

  <component :is="isView ? 'div' : 'form'" @submit.prevent="handleSubmit" class="space-y-8 divide-y divide-gray-200">
    <div class="space-y-6">
      <div class="grid grid-cols-1 gap-y-6 gap-x-4 lg:grid-cols-12">
        <div class="lg:col-span-5">
          <label for="name" class="block text-sm font-medium text-gray-700"> Nom </label>
          <div class="mt-1 flex rounded-md">
            <input
              v-model="formValues.name"
              type="text"
              name="name"
              id="name"
              :disabled="view"
              class="block w-full sm:text-sm shadow-sm focus:ring-indigo-500 focus:border-indigo-500 border rounded-md"
              :class="{ 'border-gray-200': !isView, 'bg-gray-200 border-gray-200': isView }"
            />
          </div>
        </div>
      </div>

      <div class="grid grid-cols-1 gap-y-4 gap-x-4 lg:grid-cols-12">
        <div class="lg:col-span-4">
          <label for="email" class="block text-sm font-medium text-gray-700"> E-mail </label>
          <div class="mt-1 flex rounded-md">
            <input
              v-model="formValues.email"
              type="text"
              name="email"
              id="email"
              :disabled="view"
              class="block w-full sm:text-sm shadow-sm focus:ring-indigo-500 focus:border-indigo-500 border rounded-md"
              :class="{ 'border-gray-200': !isView, 'bg-gray-200 border-gray-200': isView }"
            />
          </div>
        </div>
        <div class="lg:col-span-4">
          <label for="phone" class="block text-sm font-medium text-gray-700"> Téléphone </label>
          <div class="mt-1 flex rounded-md">
            <input
              v-model="formValues.phone"
              type="text"
              name="phone"
              id="phone"
              :disabled="view"
              class="block w-full sm:text-sm shadow-sm focus:ring-indigo-500 focus:border-indigo-500 border rounded-md"
              :class="{ 'border-gray-200': !isView, 'bg-gray-200 border-gray-200': isView }"
            />
          </div>
        </div>
      </div>

      <div class="grid grid-cols-1 gap-y-4 gap-x-4 lg:grid-cols-12">
        <div class="lg:col-span-3">
          <label for="vat" class="block text-sm font-medium text-gray-700"> Numéro de TVA </label>
          <div class="mt-1 flex rounded-md">
            <input
              v-model="formValues.vat"
              type="text"
              name="vat"
              id="vat"
              :disabled="view"
              class="block w-full sm:text-sm shadow-sm focus:ring-indigo-500 focus:border-indigo-500 border rounded-md"
              :class="{ 'border-gray-200': !isView, 'bg-gray-200 border-gray-200': isView }"
            />
          </div>
        </div>
      </div>

      <div class="mt-6 grid grid-cols-1 gap-y-2 gap-x-4 lg:grid-cols-12">
        <div class="lg:col-span-5">
          <label for="street" class="block text-sm font-medium text-gray-700"> Rue </label>
          <div class="mt-1 flex rounded-md">
            <input
              v-model="formValues.street"
              type="text"
              name="street"
              id="street"
              :disabled="view"
              class="block w-full sm:text-sm shadow-sm focus:ring-indigo-500 focus:border-indigo-500 border rounded-md"
              :class="{ 'border-gray-200': !isView, 'bg-gray-200 border-gray-200': isView }"
            />
          </div>
        </div>
        <div class="lg:col-span-2">
          <label for="housenumber" class="block text-sm font-medium text-gray-700"> Numéro / Boite </label>
          <div class="mt-1 flex rounded-md">
            <input
              v-model="formValues.housenumber"
              type="text"
              name="housenumber"
              id="housenumber"
              :disabled="view"
              class="block w-full sm:text-sm shadow-sm focus:ring-indigo-500 focus:border-indigo-500 border rounded-md"
              :class="{ 'border-gray-200': !isView, 'bg-gray-200 border-gray-200': isView }"
            />
          </div>
        </div>
        <div class="lg:col-span-5"></div>
        <div class="lg:col-span-2">
          <label for="zip" class="block text-sm font-medium text-gray-700"> Code Postal </label>
          <div class="mt-1 flex rounded-md">
            <input
              v-model="formValues.zip"
              type="text"
              name="zip"
              id="zip"
              :disabled="view"
              class="block w-full sm:text-sm shadow-sm focus:ring-indigo-500 focus:border-indigo-500 border rounded-md"
              :class="{ 'border-gray-200': !isView, 'bg-gray-200 border-gray-200': isView }"
            />
          </div>
        </div>
        <div class="lg:col-span-3">
          <label for="city" class="block text-sm font-medium text-gray-700"> Ville </label>
          <div class="mt-1 flex rounded-md">
            <input
              v-model="formValues.city"
              type="text"
              name="city"
              id="city"
              :disabled="view"
              class="block w-full sm:text-sm shadow-sm focus:ring-indigo-500 focus:border-indigo-500 border rounded-md"
              :class="{ 'border-gray-200': !isView, 'bg-gray-200 border-gray-200': isView }"
            />
          </div>
        </div>
        <div class="lg:col-span-7"></div>
        <div class="lg:col-span-3">
          <label for="country" class="block text-sm font-medium text-gray-700"> Pays </label>
          <div class="mt-1 flex rounded-md">
            <select
              v-model="formValues.country"
              name="country"
              id="country"
              :disabled="view"
              class="p-2 block w-full sm:text-sm shadow-sm focus:ring-indigo-500 focus:border-indigo-500 border rounded-md"
              :class="{ 'border-gray-200': !isView, 'bg-gray-200 border-gray-200': isView }"
            >
              <option
                v-for="(label, value) in countries"
                :key="value"
                :value="value"
                :selected="value === formValues.country"
              >
                {{ label }}
              </option>
            </select>
          </div>
        </div>
      </div>
    </div>

    <div class="pt-5">
      <div class="flex">
        <button
          v-if="isNew || isEdit"
          :disabled="disableButtons"
          type="submit"
          class="inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
        >
          <i v-if="disableButtons" class="fas fa-spinner mt-1"></i>
          <span v-else>Sauvegarder</span>
        </button>
        <router-link
          v-if="view"
          :disabled="disableButtons"
          :to="`/clients/${id}/edit`"
          class="inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
        >
          <i v-if="disableButtons" class="fas fa-spinner mt-1"></i>
          <span v-else>Modifier</span>
        </router-link>
      </div>
    </div>
  </component>
</template>

<script>
import { computed, onMounted, ref } from 'vue'
import useApi from '@/hooks/useApi'
import { useRouter } from 'vue-router'
import countries from '@/assets/countries'

export default {
  props: {
    id: [String, Number],
    view: Boolean,
  },
  setup(props) {
    const router = useRouter()
    const formValues = ref({
      name: '',
      email: '',
      phone: '',
      vat: '',
      street: '',
      housenumber: '',
      zip: '',
      city: '',
      country: 'Belgique',
    })

    const isNew = computed(() => !props.view && (!props.id || !(props.id > 0)))
    const isEdit = computed(() => !props.view && !!props.id)
    const isView = computed(() => !!props.view && !!props.id)
    const disableButtons = ref(true)

    onMounted(() => {
      setTimeout(
        () => {
          disableButtons.value = false
        },
        isView.value ? 0 : 1000,
      )
    })

    const api = useApi()
    if (!isNew.value && props.id) {
      api.clients.get({ id: props.id }).then(({ data }) => {
        formValues.value = data
      })
    }

    const handleSubmit = () => {
      if (isView.value) return
      if (isNew.value) {
        api.clients.create(formValues.value).then(() => {
          router.push('/clients')
        })
        return
      }
      if (isEdit.value) {
        api.clients.edit(formValues.value).then(() => {
          router.push('/clients')
        })
        return
      }
    }

    return { isNew, isEdit, isView, disableButtons, formValues, countries, handleSubmit }
  },
}
</script>

<style></style>
